export interface DepartureCity {
  id: number;
  name: string;
}

export enum DepartureCityId {
  SaintPetersburg = 1,
  Moscow = 2,
  Ekaterinburg = 25,
  Kazan = 29,
  Novosibirsk = 53,
  Samara = 64,
}
